
@switch (columnId) {
  @case ('email') {
    <lib-text-table-column>
      {{ element.email }}
    </lib-text-table-column>
  }
  @case ('firstName') {
    <lib-text-table-column>
      {{ element.firstName }}
    </lib-text-table-column>
  }
  @case ('lastName') {
    <lib-text-table-column>
      {{ element.lastName }}
    </lib-text-table-column>
  }
  @case ('lockedStatus') {
    <lib-user-status-icon
      [isLocked]="element.isLockedOut">
    </lib-user-status-icon>
    <lib-table-column-sort [key]="sortingKeyForLockedStatus"></lib-table-column-sort>
  }
  @default {
  }
}





